import { Global } from '../../global'
import { UtilityService } from '../../../services/Acc_Utility.service';
import { GL_Category } from '../../../models/GL_Category';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GL_Child } from '../../../models/GL_Child';
import { GL_Master } from '../../../models/GL_Master';
import {GL_MasterService} from '../../../services/Acc_GL_Master.service';
import { St_Departments } from '../../../models/St_Departments';

@Component({
  selector: 'app-gl-child-add',
  templateUrl: './gl-child-add.component.html',
  styleUrls: ['./gl-child-add.component.css']
})
export class GlChildAddComponent implements OnInit {

  ArrLabels: any;
  labels: any = {};

  GL_Child: GL_Child = {
    GL_MasterCode: "",
    GL_ChildCode: "",
    GL_ChildDesc: "",
    GL_ChildDesc_en: "",
    CurrentBalance: 0,
    RecordStat: "O",
    AuthStat: "A",
    MakerID: "test",
    CheckerID: "test",
    CreateDate: new Date(),
    UDF1: '',
    UDF2: '',
    UDF3: ''
  };
  changeDep(a) {
    this.GL_Child.UDF1 = a;
    if (a == 0)
      this.GL_Child.UDF1 = "";
  }

  gl_Master: GL_Master = {
    GL_Code: "",
    GL_Desc: "",
    GL_Desc_en: "",
    GL_CategoryDesc: "",
    GL_CategoryDesc_en: "",
    GL_CategoryID: 0,
    RecordStat: "",
    AuthStat: "",
    MakerID: "",
    CheckerID: "",
    CreateDate: new Date(),
    branchId: 0,
    branchName:''
  };
  departments: any = {};
  getDepartments() {
    this.GL_MasterService.getDepartments().subscribe(a => { this.departments = a; this.GL_Child.UDF1 = a[0]["departmentID"] });
  }
  constructor(
    private GL_MasterService: GL_MasterService,
    private UtilityService: UtilityService,
    private global: Global,
    private route : ActivatedRoute,
    private router: Router)
     { 
    route.params.subscribe( p => {this.gl_Master.GL_Code = p['gL_Code'];this.GL_Child.GL_MasterCode = p['gL_Code']; });
  }

  ngOnInit() {
    this.getDepartments();
    this.getLabels();
  }
  submit()
  {
    console.log("after submit...");
    console.log(this.GL_Child);
    this.GL_MasterService.AddGL_child(this.GL_Child)
      .subscribe (result => {
        {console.log("insert scucceed.");
          this.router.navigate(['/gl_master/' + this.gl_Master.GL_Code])}
      },
      error => console.log("error --> " + error))
      
  }

  getLabels(){
    this.UtilityService.getLabels('gl-child-add',this.global.lang)
      .subscribe(response => {
          if(response){
              this.ArrLabels = response;
              this.setLabels();
          }
      },
      error => console.log(error))
}

setLabels(){

  this.labels['gl-child-add-Title'] = this.ArrLabels.find( (o:any) => o.key === 'gl-child-add-Title').value;
  this.labels['AccountID'] = this.ArrLabels.find( (o:any) => o.key === 'AccountID').value;
  this.labels['MasterAccountID'] = this.ArrLabels.find( (o:any) => o.key === 'MasterAccountID').value;
  this.labels['AccountName'] = this.ArrLabels.find( (o:any) => o.key === 'AccountName').value;
  this.labels['AccountName_en'] = this.ArrLabels.find( (o:any) => o.key === 'AccountName_en').value;

  // alerts
  this.labels['AccountIDMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'AccountIDMandatory').value;
  this.labels['AccountNameMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'AccountNameMandatory').value;
  
  // shared lables
  this.labels['CreateDate'] = this.ArrLabels.find( (o:any) => o.key === 'CreateDate').value;
  this.labels['RecordStat'] = this.ArrLabels.find( (o:any) => o.key === 'RecordStat').value;
  this.labels['AuthStat'] = this.ArrLabels.find( (o:any) => o.key === 'AuthStat').value;
  this.labels['CheckerID'] = this.ArrLabels.find( (o:any) => o.key === 'CheckerID').value;
  this.labels['MakerID'] = this.ArrLabels.find( (o:any) => o.key === 'MakerID').value;
}

}



// WEBPACK FOOTER //
// ./src/app/components/GLs/gl-child-add/gl-child-add.component.ts